import Mark from "./Mark.ts";
import IMark from "../interfaces/IMark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import DecodingModel from "../models/DecodingModel.ts";
import RhColors from "@/models/RhColors.ts";

export default class RainbowJSMark extends Mark implements IMark
{
    private letter:string;

    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, letter:string="j", color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this.letter = letter;
        this._init();
    }

    private _init():void
    {
        this.markWidth = 85;
        this.markHeight = 18;
        this.markY = this.markHeight;
        this.strokeThickness = 5;

        if(this.targetTextField)
        {
            this.targetTextFieldStyle = this.targetTextField.style;
            this.markHeight = this.adjustToScale(36)*this.multipleOfDefaultFontSize;
            this.markY = this.targetTextField.height/2;
            this.padding = 20*this.multipleOfDefaultFontSize;
            this.parentTarget = this.targetTextField;
            this.strokeThickness = Number(this.targetTextFieldStyle.fontSize)/20;
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const mark = new Container();
        const graphicsW = this.markWidth-(this.padding*2);
        const graphicsH = this.markHeight;
        const divisorW = 5;
        const divisorH = 2.9;
        let letterY = this.adjustToScale(32);
        if(this.letter == "j")
        {
            letterY = this.adjustToScale(38);
        }
        const style = new TextStyle({
            fontFamily: DecodingModel.getInstance().fontFamily,
            fontSize: 42,
            fill: color,
            align: 'center'
        });
        if(this.targetTextField)
        {
            let defaultFontSize = 80;
            letterY = this.adjustToScale(56)*this.multipleOfDefaultFontSize;
            if(this.letter == "j")
            {
                if(this.targetTextField.text == "g")
                {
                    defaultFontSize = 60;
                    letterY = this.adjustToScale(58)*this.multipleOfDefaultFontSize;
                    this.markY -= this.adjustToScale(36)*this.multipleOfDefaultFontSize;
                }
                else
                {
                    letterY = this.adjustToScale(66)*this.multipleOfDefaultFontSize;
                    this.markY -= this.adjustToScale(40)*this.multipleOfDefaultFontSize;
                }
            }
            else
            {
                if(this.targetTextField.text == "c")
                {
                    defaultFontSize = 60;
                    letterY = this.adjustToScale(48)*this.multipleOfDefaultFontSize;
                    this.markY -= this.adjustToScale(38)*this.multipleOfDefaultFontSize;
                }
                else
                {
                    this.markY -= this.adjustToScale(42)*this.multipleOfDefaultFontSize;
                }
            }
            style.fontSize = defaultFontSize*this.multipleOfDefaultFontSize;
        }

        const gr = new Graphics();
        gr.moveTo(0, graphicsH);
        gr.bezierCurveTo(graphicsW/divisorW, -(this.markHeight/divisorH), graphicsW-(graphicsW/divisorW), -(this.markHeight/divisorH), graphicsW, graphicsH);
        gr.stroke({width:this.strokeThickness, color:color, cap:"round"});
        gr.x = this.padding;
        gr.y = this.markY;
        mark.addChild(gr);

        const letter = new Text({text:this.letter, style:style});
        letter.x = gr.x+(graphicsW / 2) - (letter.width / 2);
        letter.y = this.markY-((letterY+letterY/2)+4);
        mark.addChild(letter);

        mark.scale.set(this.textScale);
        //mark.cacheAsBitmap = true;
        mark.visible = visible;
        this.addChild(mark);
        this.markHeight += (letterY+this.adjustToScale(18));
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks():void
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}